const config = {
    // API_BASE_URL: 'https://localhost:8000',
    API_BASE_URL: 'https://api.akygacomponents.com:8443',
    // API_BASE_URL: 'https://localhost:8443'
    // API_BASE_URL: 'http://aba.akygacomponents.com:8000'
};

export default config;